import $ from 'zepto';

import {
  $$$,
} from '../../../utils/legacy';

import { isVisible, log } from '../../../utils';
import { initPopups } from '../tooltips';

import {
  FOCUS,
  SCROLL_BAR_EXTRA,
  CLEAR_INPUT_DELAY,
} from '../../../utils/legacy/constants';

import {
  WRAPPER_MARKUP,
  COUNTRY_MARKUP,
  PULLDOWN_MARKUP,
  INPUT_MARKUP,
  SEL_COUNTRY,
} from '../../../utils/legacy/templateConstants';

/**
 * Sets width of original element to custom dropdown in order to match both elements
 * @method adjustDropDownWidthBeforeShowing
*/
export function adjustDropDownWidthBeforeShowing() {
  let newPulldownWidth = this.customPulldownContentWidth;
  // fluid responsive code:
  this.$originalHtmlSelectElement.show(); // show the original element so that we can get the width;
  this.originalHtmlSelectElementWidth = this.$originalHtmlSelectElement[0].offsetWidth; // get the width
  this.$originalHtmlSelectElement.hide(); // hide original element now that we have the width
  // Don't make options pulldown narrower than the original HTML select element
  if (this.customPulldownContentWidth < this.originalHtmlSelectElementWidth) {
    newPulldownWidth = this.originalHtmlSelectElementWidth;
  }
  // update the drop down width
  this.dropDown.setOption('width', newPulldownWidth);
}

/**
 * If needed it sets scroll to custom pulldown
 * @method setScrollWhilePulldown
 * @param {Event} e Event object
*/
function setScrollWhilePulldown(e) {
  const originalEvent = e.originalEvent || e;
  const delta = originalEvent.wheelDelta || -originalEvent.detail;
  const { currentTarget } = e;

  if ((delta > 0) && ($(currentTarget).scrollTop() <= 0)) {
    return false;
  }
  if ((delta < 0) && $(currentTarget).scrollTop() >= (currentTarget.scrollHeight - $(currentTarget).height())) {
    return false;
  }

  return true;
}

/**
 * Removes css classes that show an item as selected in custom pulldown
 * @method unhiliteField
*/
export function unhiliteField() {
  $('.customSelect', this.$customPulldownFieldElement).removeClass(FOCUS);
  this.$customPulldownFieldElement.removeClass('custom-pulldown-popup-isabove custom-pulldown-popup-isbelow');
}

/**
 * Hides custom pulldown and clear timeout for showPulldownTimeout
 * @method hidePulldown
*/
export function hidePulldown() {
  clearTimeout(this.showPulldownTimeout);
  this.unhiliteField();
  this.dropDown.hide();
}

/**
 * Adds css class that show an item as selected in custom pulldown
 * @method hiliteField
*/
export function hiliteField() {
  $('.customSelect', this.$customPulldownFieldElement).addClass(FOCUS);
}

/**
 * Ensures that the specified module exists in memory
 * @method objectTest
 * @param {String} moduleName Specify the module name that is going to be verified
*/
export function objectTest(moduleName) {
  let mod = window.xoom;
  const parts = moduleName.split('.');
  const partsLength = parts.length;

  for (let i = 0; i < partsLength; i += 1) {
    if (i !== 0) {
      mod = mod[parts[i]];
    }
    if (!mod) {
      break;
    }
  }
  return mod;
}

/**
 * Updates original element with selected item in custom pulldown and update visual selected item
 * in custom pulldown.
 * @method updateVisualsWithSelItem
*/
export function updateVisualsWithSelItem() {
  const newOpt = $('select option', this.$originalHtmlSelectElement)
    .filter(function selected() { return this.selected; });

  let newOptTitle = newOpt.attr('title');
  if (!newOptTitle) {
    newOpt.attr('title', '');
    newOptTitle = newOpt.attr('title');
  }
  const newOptClass = newOpt.attr('class') || '';
  const newOptText = newOpt.text().escapeHTML() || '';
  let displayString = SEL_COUNTRY.replaceTokens(newOptClass,
    newOptText,
    newOptTitle.escapeHTML());

  if (this.updateVisualCallback) {
    displayString = this.updateVisualCallback(newOpt);
  }
  this.$selectedItemDisplayElement.html(displayString);

  // update the markup stored in the dropDown 'customPulldownTargetElement' attribute.
  this.dropDown.setOption('customPulldownTargetElement', this.$customPulldownFieldElement.html());
}

/**
 * After selecting an item in custom pulldown a callback is called, if no callback is called the user
 * is returned to the hidden field after selecting an item.
 * @method chooseCallback
 * @param {domElement} stayOnField Element where the custom pulldown open
 * @param {Event} event Event object
*/
export function chooseCallback(stayOnField, event) {
  // data-pulldown-after-selection specifies a custom callback to be run after the user has made a selection
  if (this.afterSelectionCallbackName && !this.afterSelectionCallback) {
    this.afterSelectionCallback = this.objectTest(this.afterSelectionCallbackName);
  }

  if (this.afterSelectionCallback) {
    // Use custom supplied callback if available
    this.afterSelectionCallback.apply(this.$originalHtmlSelectElement[0], [event]);
  } else if (stayOnField) {
    // return the user to the hidden field after
    // they clicked on a selection in the custom pulldown
    // We need this so that they can tab to the next field
    // successfully.
    this.hiliteField();
    this.$inputElt.trigger('softfocus');
  }
}

/**
 * Updates custom pulldown and original element with the chosen item
 * @method chooseCountry
*/
export function chooseCountry() {
  if (this.$originalHtmlSelectElement.val() !== this.savedChoice) {
    this.$originalHtmlSelectElement.trigger('change');
    this.savedChoice = this.$originalHtmlSelectElement.val();
  }

  this.hidePulldown();
  this.updateVisualsWithSelItem();
}

/**
 * Shows or hide custom pulldown if this has items
 * @method togglePulldown
*/
export function togglePulldown() {
  // toggle only if there are options. Otherwise ignore click.
  if ($('.countryItem', this.$pickerElt).length > 0) {
    if (isVisible(this.$pickerElt)) {
      this.hidePulldown();
    } else {
      this.$inputElt.trigger(FOCUS);
    }
  }
}

/**
 * Clears input on custom pulldown
 * @method clearInput
*/
export function clearInput() {
  this.$inputElt.val('');
}

/**
 * Returns if option has valid values
 * @method getOptionsFlag
 * @param {String} optionVal Option element value
 * @param {domElement} $option Options element
 * @param {String} emptyOptionValue Constant string used in data attribute for option element
*/
export function getOptionsFlag(optionVal, $option, emptyOptionValue) {
  return (optionVal === '') && !($option.hasClass(emptyOptionValue)
    || $option.data(emptyOptionValue));
}

/**
 * Gets options markup for each custom pulldown. It set visual display settings for each item in
 * custom pulldown
 * @method getOptionsMarkup
 * @param {domElement} $options Options element
*/
export function getOptionsMarkup($options) {
  const PULLDOWN_LINEITEM = '<div class="countryItem" id="{0}">{1}</div>';
  const pulldownItems = [];
  let selectedOption = '';

  for (let i = 0, iLen = $options.length; i < iLen; i += 1) {
    const option = $options[i];
    const $option = $(option);
    const optionVal = $option.val();
    const optionHtml = option.innerHTML;
    // don't use jQuery's .html() method here because it could render any markup in the option tag,
    // thus causing XSS vulnerability
    const optionClass = option.className;
    const optionTitle = option.title.escapeHTML(); // escape this to prevent XSS vulnerability
    let countryItem = SEL_COUNTRY.replaceTokens(optionClass, optionHtml, optionTitle);
    const emptyOptionValue = 'show-empty-option';

    if ($option.attr('selected')) {
      if (optionVal) {
        selectedOption = SEL_COUNTRY.replaceTokens(optionClass, optionHtml, optionTitle);

        if (this.updateVisualCallback) {
          selectedOption = this.updateVisualCallback($option);
        }
      } else {
        selectedOption = optionHtml;
      }
    }

    if (this.createRowCallbackFunction) {
      /* createRowCallbackFunction is used to create a custom visual display for each "option" (aka item)
      * in the pull-down. Using this method, we can display complex markup in the "option".
      * */
      countryItem = this.createRowCallbackFunction($option);

      /* customText is referenced when using the keyboard to select an item from the list
      * by typing the first few characters of that item.  This will override the default which matches
      * the text in the original HTML option tag.
      *
      * We do this so that when the user types matches what is seen in the pull-down when we are using
      * this createRowCallbackFunction.
      * */
      option.customText = $(countryItem).text();
    }

    // hide empty options unless specified otherwise
    const emptyOptionFlag = this.getOptionsFlag(optionVal, $option, emptyOptionValue);
    if (!emptyOptionFlag) {
      pulldownItems.push(PULLDOWN_LINEITEM.replaceTokens(optionVal, countryItem));
    }
  }

  return ({
    selectedCountry: selectedOption,
    optionsHtml: pulldownItems.join(''),
  });
}

/**
 * Updates visual of custom pulldown items
 * @method updateOptionsList
*/
export function updateOptionsList() {
  const pulldownElement = $$$(`${this.$originalHtmlSelectElement[0].id}-sel`);
  const options = $('option', this.$originalHtmlSelectElement[0]);
  const markup = this.getOptionsMarkup(options);

  pulldownElement.html(markup.optionsHtml);

  // update visuals of selected item
  this.savedChoice = null;
  this.updateVisualsWithSelItem();
}

/**
 * Returns the html for custom pulldown
 * @method createPulldown
 * @param {domElement} options Options element
 * @param {String} selectClass Class of select element
*/
export function createPulldown(options, selectClass) {
  /* NOTE:
  * Hard-coding the display:inline-block on custom-pulldown-wrapper to prevent UI
  * flashing when CSS is lazy loading
  */
  const markup = this.getOptionsMarkup(options);

  return (WRAPPER_MARKUP.replaceTokens(
    COUNTRY_MARKUP.replaceTokens(markup.selectedCountry, this.pickerId, selectClass),
    PULLDOWN_MARKUP.replaceTokens(markup.optionsHtml, this.pickerId),
    INPUT_MARKUP.replaceTokens(this.pickerId),
    this.pickerId,
    this.displayStyle,
  ));
}

/**
 * Returns highllightValue for custom pulldown based on position
 * @method getHighlightValue
 * @param {domElement} allOptions Country item for custom pulldown element
 * @param {String} newVal Selected element value
*/
export function getHighlightValue(allOptions, newVal) {
  let index;
  let i;
  // convert the value into an index into the $pickerElt
  for (i = 0; i < allOptions.length; i += 1) {
    if (allOptions[i].id === newVal) {
      index = i;
      break;
    }
  }

  // check for NPE, if index is not defined then we can't get allOptions[index]
  if (index !== undefined) {
    const $selectedOption = $(allOptions[index]);
    const { top } = $selectedOption.position();
    const optHt = $selectedOption.height();
    const $picker = $$$(`${this.pickerId}-sel`);
    const pickerHt = $picker.height();

    $selectedOption.addClass(FOCUS);

    if (top < 0) {
      $picker.scrollTop($picker.scrollTop() + top);
    } else if ((top + optHt) > pickerHt) {
      $picker.scrollTop($picker.scrollTop() + top - pickerHt + optHt);
    }

    return newVal;
  }
  return this.hightlightValue;
}

/**
 * Updates highlightValue to the one that was selected
 * @method hiliteItem
 * @param {String} newVal Selected element value
*/
export function hiliteItem(newVal) {
  const allOptions = $('.countryItem', this.$pickerElt);
  this.highlightValue = this.getHighlightValue(allOptions.removeClass(FOCUS), newVal);
}

/**
 * Updates selected index and highlightValue
 * @method chooseItem
 * @param {Int} index Index of selected value
*/
export function chooseItem(index) {
  this.$originalHtmlSelectElement[0].selectedIndex = index;
  this.hiliteItem(this.$originalHtmlSelectElement.val());
}

/**
 * Allows user to choose item using down arrow key
 * @method handleDownArrowKey
 * @param {domElement} currElt Current element
 * @param {Int} numOptions Options length
 * @param {Int} currIndex Current index
*/
export function handleDownArrowKey(currElt, numOptions, currIndex) {
  if (currElt.length > 0) {
    if (currIndex < (numOptions - 1)) {
      this.chooseItem(currIndex + 1);
    }
  } else {
    this.chooseItem(numOptions - 1);
  }
}

/**
 * Allows user to choose item using up arrow key
 * @method handleUpArrowKey
 * @param {domElement} currElt Current element
 * @param {Int} currIndex Current index
*/
export function handleUpArrowKey(currElt, currIndex) {
  if (currElt.length > 0) {
    if (currIndex > 0) {
      this.chooseItem(currIndex - 1);
    } else {
      this.chooseItem(0);
    }
  } else {
    this.chooseItem(0);
  }
}

/**
 * Allows user to select item using enter key
 * @method handleEnterKey
 * @param {Int} allOptions Options length
*/
export function handleEnterKey(allOptions) {
  let toMatch;
  let toMatchLen = 0;
  if (this.$inputElt && this.$inputElt.val()) {
    toMatch = this.$inputElt.val().toLowerCase();
    toMatchLen = toMatch.length;
  }

  for (let i = 0; i < allOptions.length; i += 1) {
    const option = allOptions[i];
    const optionVal = option.value;
    const val = option.customText || option.innerHTML.trim();
    const matchVal = val.substr(0, toMatchLen).toLowerCase();

    if ((optionVal.length > 0) && (matchVal === toMatch)) {
      this.chooseItem(i);
      break;
    }
  }
}

/**
 * Returns width of the custom pulldown by cloning the original pulldown content
 * @method getPulldownContentWidth
*/
export function getPulldownContentWidth() {
  const $customPulldownSizer = $('<div class="custom-pulldown-sizer" />');
  const $localPickerElt = this.$pickerElt.clone(true); // clone the pull down contents
  let contentWidth; // width of content that will appear in pulldown

  $('body').append($customPulldownSizer);

  // append cloned picker into sizing div so that we can calculate the size
  $customPulldownSizer.append($localPickerElt);

  // get the width
  contentWidth = $localPickerElt.width();

  if ($localPickerElt.css('overflow-y')) {
    const optionsHeight = $localPickerElt.height();
    const maxHeight = $localPickerElt.css('max-height');
    if (maxHeight && (optionsHeight >= parseInt(maxHeight, 10))) {
      contentWidth += SCROLL_BAR_EXTRA;
    }
  }

  // removing sizing element
  $customPulldownSizer.remove();

  return contentWidth;
}

/**
 * Focuses item without showing the pulldown
 * @method softFocus
*/
export function softFocus() {
  this.inputEltSoftFocus = true; // focus on the field without showing the pulldown
  this.$inputElt.focus();
  // if you don't do this twice, IE9 seems to fire a blur on the field even though no other browser does.
  setTimeout(() => {
    this.inputEltSoftFocus = true;
    this.$inputElt.focus();
    this.hiliteField(); // delay is needed sometimes to highlight the input element field
  }, 100);
}

/**
 * Sets bind properties for pickerElt element
 * @method setBindPropsPickerElt
*/
export function setBindPropsPickerElt() {
  const self = this;
  $(self.$pickerElt)
    .delegate('.countryItem', 'click', (event) => {
      self.selectCountry(this, event);
    })
    .delegate('.countryItem', 'mouseover', self.hiliteCountry.bind(self))
    .bind('mousewheel DOMMouseScroll', setScrollWhilePulldown.bind(self));
}

/**
 * Sets bind properties for inputElt element
 * @method setBindPropsPickerElt
*/
export function setBindPropsInputElt() {
  this.$inputElt.bind(FOCUS, this.showPulldown.bind(this))
    .bind('keyup', this.handleKey.bind(this))
    .bind('keydown', this.handleEnterTabKey.bind(this))
    .bind('softfocus', () => {
      this.softFocus();
    });

  $('body').bind('click', this.hideCountryPulldownOnClick.bind(this));
}

/**
 * Returns dropdown after being created using initPopups.add
 * @method getDropdown
*/
export function getDropdown(className) {
  return initPopups().add(this.customPulldownContentElementId, this.$customPulldownFieldElement, {
    message: this.$pickerElt,
    type: 'countryPulldown',
    className,
    positionFixed: 0,
    animate: 0,
    width: this.customPulldownContentWidth,
    align: 'left',
    scope: this.uiElementScope,
    hideOnBodyClick: true,
    zIndex: 30,
    customPulldownTargetElement: this.$customPulldownFieldElement.html(),
  });
}

/**
 * Sets visual properties for selected item of custom pulldown
 * @method setSelectedItemProps
 * @param {String} className Class to be added
*/
export function setSelectedItemProps(className) {
  const tabindex = this.$originalHtmlSelectElement.attr('tabindex');
  if (tabindex) {
    this.$inputElt.attr('tabindex', tabindex);
  }
  // add error class, if it exists, to display of chosen item
  $('.customSelect', this.$customPulldownFieldElement).addClass(className);

  this.$originalHtmlSelectElement.hide();
  // placing hiding of element -after- we insert the new content, to help reduce flickering ui*/
  this.$originalHtmlSelectElement.addClass('has-custom-pulldown');
  // add this so that other scripts will know that this item has a custom pulldown*/

  // remove the custom attribute that says we are currently in the middle of initializing the widget
  this.$originalHtmlSelectElement.removeAttr('data-custom-pulldown-initializing');
}

/**
 * Returns class selected it can be language-pulldown or country-pulldown classes
 * @method setSelectedItemProps
 * @param {String} selectClass Class to be verified
*/
export function getSelectClass(selectClass) {
  let newSelectClass = selectClass;
  if (this.$originalHtmlSelectElement.hasClass('language-pulldown')) {
    newSelectClass += '-language';
  }
  return newSelectClass;
}

/**
 * Sets callbacks to be used in custom pulldown
 * @method setCallBacks
 * @param {domElement} originalHtmlSelectDomElement Original pulldown element
*/
export function setCallBacks(originalHtmlSelectDomElement) {
  if (originalHtmlSelectDomElement.getAttribute('data-pulldown-create-row')) {
    this.createRowCallbackFunction = this.objectTest(originalHtmlSelectDomElement.getAttribute('data-pulldown-create-row'));
  }

  if (originalHtmlSelectDomElement.getAttribute('data-pulldown-update-visual')) {
    this.updateVisualCallback = this.objectTest(originalHtmlSelectDomElement.getAttribute('data-pulldown-update-visual'));
  }
  this.afterSelectionCallbackName = this.$originalHtmlSelectElement[0].getAttribute('data-pulldown-after-selection');
}

/**
 * Returns class name anidating the original class name only if exists
 * @method getClassName
 * @param {domElement} originalHtmlSelectDomElement Original pulldown element
 * @param {String} className Class name to be anidated
*/
export function getClassName(originalHtmlSelectDomElement, className) {
  let newClassName = className;
  if (originalHtmlSelectDomElement.className) {
    newClassName += ` ${originalHtmlSelectDomElement.className}`;
  }
  return newClassName;
}

/**
 * Allows to choose item using keys that has ascii code above clear key, as: 13, 27, 38, 40
 * @method handleAboveClearKey
 * @param {Event} e Event object
 *
*/
export function handleAboveClearKey(e) {
  if (e.which > 12) {
    // This fixes an IE9 issue when we tab into the hidden field on the Recipient Delivery page for PH,
    // tabbing from State to Postal code causes the browser to freeze, the JS
    // $originalHtmlSelectElement.val(highlightValue);
    // stalls the browser. To fix this, we will only run the code if one of the allowed keys is pressed
    this.$originalHtmlSelectElement.val(this.highlightValue);
    const selected = $('select option', this.$originalHtmlSelectElement)
      .filter(function selected() { return this.selected; });
    const currElt = $(selected, this.$originalHtmlSelectElement);
    const currIndex = this.$originalHtmlSelectElement[0].selectedIndex;
    const allOptions = $('option', this.$originalHtmlSelectElement);
    const numOptions = allOptions.length;

    if (e.which === 40) { // down arrow
      if (!isVisible(this.$pickerElt)) {
        this.inputEltSoftFocus = false; // so showPulldown will show drop-down
        this.showPulldown();
      } else {
        this.setArrowPressed();
      }
      this.handleDownArrowKey(currElt, numOptions, currIndex);
    } else if (e.which === 38) { // up arrow
      if (!isVisible(this.$pickerElt)) {
        this.inputEltSoftFocus = false; // so showPulldown will show drop-down
        this.showPulldown();
      } else {
        this.setArrowPressed();
      }
      this.handleUpArrowKey(currElt, currIndex);
    } else if (e.which === 27) { // escape key
      this.chooseCountry();
      this.chooseCallback(1, e);
    } else if (e.which !== 13) { // enter key handled by handleEnterKey
      this.handleEnterKey(allOptions);
    }
  }
}

/**
 * Returns value for uiElementScope. If xoom-dialog exists returns xoom-dialog, if not it returns undefined.
 * @method getUIElementScope
 *
*/
export function getUIElementScope() {
  // if we're in a dialog, set our scope to be xoom-dialog, so that
  // when the xoom.ui.Dialog is closed, it will destroy all registered UI objects within it's scope
  if ($('.xoom-dialog').find(this.$originalHtmlSelectElement).length) {
    return 'xoom-dialog';
  }
  return undefined;
}

/**
 * Sets a flag that says that an arrow key was recently pressed. Reset the flag after 250ms
 * @method setArrowPressed
 *
*/
export function setArrowPressed() {
  clearTimeout(this.arrowPressedimeout);
  this.arrowPressed = 1;
  this.arrowPressedimeout = setTimeout(() => {
    this.arrowPressed = 0;
  }, 250);
}

/**
 * Sets value for uiElementScope. If xoom-dialog exists it is setted as xoom-dialog.
 * @method getUIElementScope
 * @param {domElement} $element Element where xoom-dialog is going to be searched
 *
*/
export function setUIElementScope($element) {
  // if we're in a dialog, set our scope to be xoom-dialog, so that
  // when the xoom.ui.Dialog is closed, it will destroy all registered UI objects within it's scope
  if ($('.xoom-dialog').find($element).length) {
    this.uiElementScope = 'xoom-dialog';
  }
}

/**
 * Returs isFullWidthField value verifying if the necessary classes exists in order to change the value
 * @method getIsFullWidthFieldValue
 * @param {domElement} $element Element where classes are going to be searched
 *
*/
export function getIsFullWidthFieldValue($element) {
  if ($element.hasClass('js-field-full-width') || $element.hasClass('field-full-width')) {
    this.isFullWidthField = 1;
  }
  return this.isFullWidthField;
}

/**
 * Checks if element is already initialized by searching for data-custom-pulldown-initializing class in element
 * @method isElementInitialized
 * @param {domElement} $element Element where attributes are going to be searched
 * @param {Int} elementId Element ID
 *
*/
export function isElementInitialized($element, elementId) {
  // check to see if the element has already started initializing
  // this is to prevent race conditions when addPulldown is erroneously called twice within several milliseconds
  if ($element.attr('data-custom-pulldown-initializing') === 'true') {
    log.warn(`CustomPulldown: addPulldown() called multiple times for: ${elementId}`);
    return true;
  }
  return false;
}

/**
 * Returns the timeout, needed to ensure that element is going to be visible
 * @method getShowPulldownTimeOut
 *
*/
export function getShowPulldownTimeOut() {
  // IE9 calls this showPulldown twice. So we add a timeout to deal with it.
  return setTimeout(() => {
    if (this.inputEltSoftFocus === true) {
      this.hiliteField();
      this.inputEltSoftFocus = false;
    } else {
      this.dropDown.show();
      this.hiliteField();
      // reset the selected item
      // use a timeout because on some browsers, the element is not visible before we call hiliteItem
      setTimeout(() => {
        this.hiliteItem(this.$originalHtmlSelectElement.val());
      }, 100);
    }
  }, 100);
}

/**
 * Returns display style as block if display is full width
 * @method getDisplayStyle
 * @param {Boolean} isFullWidth Flag to verify if display is full width
 *
*/
export function getDisplayStyle(isFullWidth) {
  if (isFullWidth) {
    return 'block';
  }
  return this.displayStyle;
}

/**
 * Returns customPulldownDimensions depending if display is full width
 * @method getCustomPullDownDimensions
 * @param {Boolean} isFullWidth Flag to verify if display is full width
 * @param {Object} customPulldownFieldDimensions Object with width and height attributes
 * @param {Int} height Original element height
 *
*/
export function getCustomPullDownDimensions(isFullWidth, customPulldownFieldDimensions, height) {
  if (!isFullWidth) {
    return {
      width: this.originalHtmlSelectElementWidth,
      height,
    };
  }
  return customPulldownFieldDimensions;
}

/**
 * Returns object with attributes obtained of original element. This elememt is used in init.
 * @method getLocalObject
 *
*/
export function getLocalObject() {
  const domElement = this.$originalHtmlSelectElement[0];
  return {
    originalHtmlSelectDomElement: domElement,
    options: $('option', domElement),
    height: domElement.offsetHeight,
    selectClass: this.getSelectClass('custom-select'),
  };
}

/**
 * Sets css attributes in order to disable auto formatting of phone numbers in Microsoft Edge
 * @method setEdgeAttributes
 *
*/
export function setEdgeAttributes() {
  this.dropDown.get()[0].setAttribute('x-ms-format-detection', 'none');
  this.$customPulldownFieldElement[0].setAttribute('x-ms-format-detection', 'none');
}

/**
 * Calls in a safety way a callback
 * @method safeCallbackCall
 * @param {callback} callback Callback to be called
 *
*/
export function safeCallbackCall(callback) {
  if (callback) {
    callback();
  }
}

/**
 * Unbinds properties for body and pickerElt
 * @method unbindProps
 *
*/
export function unbindProps() {
  $('body').unbind('click', this.hideCountryPulldownOnClick).bind(this);
  this.$pickerElt.unbind();
}

/**
 * Hides custom pulldown on click calling hidePulldown function
 * @method hideCountryPulldownOnClick
 * @param {Event} ev Event object
 *
*/
export function hideCountryPulldownOnClick(ev) {
  const targetElt = $(ev.target);
  if ($$$(`${this.pickerId}-wrap`).find(targetElt).length === 0) {
    this.hidePulldown();
  }
}

/**
 * Shows custom pulldown and update showPulldownTimeout value
 * @method showPulldown
 *
*/
export function showPulldown() {
  clearTimeout(this.showPulldownTimeout);
  this.adjustDropDownWidthBeforeShowing();
  this.showPulldownTimeout = this.getShowPulldownTimeOut();
}

/**
 * Allows user to choose item with enter and tab keys
 * @method handleEnterTabKey
 * @param {Event} ev Event object
 *
*/
export function handleEnterTabKey(e) {
  if (e.which === 13) { // enter key
    this.chooseCountry();
    this.chooseCallback(1, e);
    e.preventDefault();
  } else if (e.which === 9) { // tab key
    this.chooseCountry();
    this.chooseCallback(0, e);
  }
}

/**
 * Allows user to choose item with keys, must happen on keyUp, so the key has already been
 * entered into the input field
 * @method handleKey
 * @param {Event} ev Event object
 *
*/
export function handleKey(e) {
  clearTimeout(this.clearInputTimeout);
  this.clearInputTimeout = setTimeout(this.clearInput(), CLEAR_INPUT_DELAY);
  this.handleAboveClearKey(e);
}

/**
 * Don't highlight item when arrow key causes scrolling
 * @method hiliteCountry
 * @param {Event} ev Event object
 *
*/
export function hiliteCountry(ev) {
  if (!this.arrowPressed) {
    this.hiliteItem(ev.currentTarget.id);
  }
}

/**
 * Allows to update the item selected verifying first if it is not disabled
 * @method selectCountry
 * @param {domElement} selectedEl Selected element
 * @param {Event} ev Event object
 *
*/
export function selectCountry(selectedEl, ev) {
  if (!$(selectedEl).children().hasClass('disabled')) {
    this.$originalHtmlSelectElement.val(ev.currentTarget.id);
    this.chooseCountry();
    this.chooseCallback(1, ev);
    this.savedChoice = ev.currentTarget.id; // reset saved choice
  }
}

export default {
  adjustDropDownWidthBeforeShowing,
  unhiliteField,
  hidePulldown,
  hiliteField,
  objectTest,
  updateVisualsWithSelItem,
  chooseCallback,
  chooseCountry,
  togglePulldown,
  clearInput,
  getOptionsFlag,
  getOptionsMarkup,
  updateOptionsList,
  createPulldown,
  getHighlightValue,
  hiliteItem,
  chooseItem,
  handleDownArrowKey,
  handleUpArrowKey,
  handleEnterKey,
  getPulldownContentWidth,
  softFocus,
  setBindPropsPickerElt,
  setBindPropsInputElt,
  getDropdown,
  setSelectedItemProps,
  getSelectClass,
  setCallBacks,
  getClassName,
  handleAboveClearKey,
  getUIElementScope,
  setArrowPressed,
  setUIElementScope,
  getIsFullWidthFieldValue,
  getShowPulldownTimeOut,
  getDisplayStyle,
  getCustomPullDownDimensions,
  getLocalObject,
  setEdgeAttributes,
  unbindProps,
  hideCountryPulldownOnClick,
  showPulldown,
  handleEnterTabKey,
  handleKey,
  hiliteCountry,
  selectCountry,
};
